<ng-container *rxLet="vm$; let vm;">
  <div class="files-total-size" *ngIf="vm.maxFilesSizeError">
    Total size of all files should be less than {{vm.maxFilesSizeError.maxFilesSize / (1000 * 1000)}} MB.
  </div>
</ng-container>
